// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-container {
  min-height: auto;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  position: relative;
}

.forgot-password-content {
  flex: 1 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px;
  margin: 0 auto;
  width: 100%;
  min-height: calc(100vh - 170px);
}

.forgot-password-left {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sync-animation {
  width: 100%;
  max-width: 600px;
  position: relative;
}

.forgot-password-form-container {
  background-color: #0066cc;
  padding: 40px;
  border-radius: 8px;
  width: 400px;
  color: white;
}

.forgot-password-title {
  font-size: 32px;
  margin-bottom: 30px;
  text-align: center;
  font-weight: 500;
  color: white;
}

.form-group {
  margin-bottom: 20px;
}

.form-input {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
}

.forgot-submit-button {
  width: 100%;
  padding: 12px;
  background-color: #001f3f;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin: 20px 0;
  font-weight: 500;
}

.submit-button:hover {
  background-color: #003366;
}

.back-to-login {
  text-align: center;
  margin-top: 20px;
}

.back-to-login a {
  color: white;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
}

.back-to-login a:hover {
  text-decoration: underline;
} `, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".forgot-password-container {\n  min-height: auto;\n  display: flex;\n  flex-direction: column;\n  background-color: #f5f5f5;\n  position: relative;\n}\n\n.forgot-password-content {\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 40px;\n  margin: 0 auto;\n  width: 100%;\n  min-height: calc(100vh - 170px);\n}\n\n.forgot-password-left {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sync-animation {\n  width: 100%;\n  max-width: 600px;\n  position: relative;\n}\n\n.forgot-password-form-container {\n  background-color: #0066cc;\n  padding: 40px;\n  border-radius: 8px;\n  width: 400px;\n  color: white;\n}\n\n.forgot-password-title {\n  font-size: 32px;\n  margin-bottom: 30px;\n  text-align: center;\n  font-weight: 500;\n  color: white;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  background-color: white;\n}\n\n.forgot-submit-button {\n  width: 100%;\n  padding: 12px;\n  background-color: #001f3f;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  margin: 20px 0;\n  font-weight: 500;\n}\n\n.submit-button:hover {\n  background-color: #003366;\n}\n\n.back-to-login {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.back-to-login a {\n  color: white;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.back-to-login a:hover {\n  text-decoration: underline;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
